import * as types from '../../contactUs/constants/ActionTypes';

const initialState = {
  display: false,
  isLoading: false,
  error: false,
  article: undefined,
  relatedArticles: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ARTICLE:
      return {
        ...state,
        isLoading: true,
        error: false,
        article: undefined,
        display: true,
      };

    case types.RECEIVE_ARTICLE_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        article: action.payload,
        relatedArticles: action.payload && action.payload.relatedArticles,
      };

    case types.RECEIVE_ARTICLE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        article: undefined,
      };
    case types.RESET_RELATED_ARTICLE:
      return { ...state, relatedArticles: [] };
    default:
      return state;
  }
}
